<template>
    <div class="table-footer">
        <div class="left">
            <div class="record-count">{{ $t("tables.recordCount") }}: {{ recordCount }}</div>

            <SupsisButton class="increase-limit-btn" :disabled="true" @click="increaseLimit" v-if="false">
                <i class="material-icons">add</i> {{ $t("tables.increaseLimit") }}
            </SupsisButton>

            <PermissionController :permissions="['table.update']">
                <a-tooltip v-if="isRecordLimitExceeded" placement="top">
                    <template slot="title">
                        Kayıt limiti doldu. Yeni kayıt eklemek için plan yükseltmeniz gerekiyor.
                    </template>
                    <a-badge :count="isRecordLimitExceeded ? '!' : 0" :number-style="{ backgroundColor: '#ff4d4f' }">
                        <SupsisButton
                            v-if="canCreateRecord"
                            class="new-record-btn"
                            @click="$feature.beforeCreateTableRecord(createNewRecord, recordCount)"
                        >
                            <i class="material-icons">add_box</i> {{ $t("tables.newRecord") }}
                        </SupsisButton>
                    </a-badge>
                </a-tooltip>
                <SupsisButton
                    v-if="!isRecordLimitExceeded && canCreateRecord"
                    class="new-record-btn"
                    @click="$feature.beforeCreateTableRecord(createNewRecord, recordCount)"
                >
                    <i class="material-icons">add_box</i> {{ $t("tables.newRecord") }}
                </SupsisButton>
            </PermissionController>
            <PermissionController :permissions="['table.update']">
                <a-tooltip v-if="isRecordLimitExceeded" placement="top">
                    <template slot="title">
                        Kayıt limiti doldu. Kayıt içeri aktarmak için plan yükseltmeniz gerekiyor.
                    </template>
                    <a-badge :count="isRecordLimitExceeded ? '!' : 0" :number-style="{ backgroundColor: '#ff4d4f' }">
                        <SupsisButton
                            v-if="canImportRecords"
                            class="import-btn"
                            @click="$feature.beforeCreateTableRecord(importRecords, recordCount)"
                        >
                            <i class="material-icons">cloud_upload</i> {{ $t("tables.imports") }}
                        </SupsisButton>
                    </a-badge>
                </a-tooltip>
                <SupsisButton
                    v-if="!isRecordLimitExceeded && canImportRecords"
                    class="import-btn"
                    @click="$feature.beforeCreateTableRecord(importRecords, recordCount)"
                >
                    <i class="material-icons">cloud_upload</i> {{ $t("tables.imports") }}
                </SupsisButton>
            </PermissionController>
            <a-popover v-if="canExportRecords" trigger="click" placement="topLeft">
                <template slot="content">
                    <div class="action-menu">
                        <div 
                            class="action-item" 
                            :class="{ disabled: !hasSelection }"
                            @click.stop="hasSelection && exportSelectedRecords()"
                        >
                            <i class="material-icons" style="color: #52c41a">check_box</i>
                            {{
                                hasSelection
                                    ? `Seçilenleri İndir (${selectedRecordsCount})`
                                    : "Seçilenleri İndir"
                            }}
                        </div>
                        <div class="action-item" @click.stop="openExport('page')">
                            <i class="material-icons" style="color: #faad14">file_download</i>
                            Bu Sayfayı İndir
                        </div>
                        <div class="action-item" @click.stop="openExport('all')">
                            <i class="material-icons" style="color: #faad14">cloud_download</i>
                            Tümünü İndir
                        </div>
                    </div>
                </template>
                <SupsisButton class="export-btn">
                    <i class="material-icons">cloud_download</i> {{ $t("tables.exports") }}
                </SupsisButton>
            </a-popover>
            <SupsisButton class="ai-assistant-btn" @click="showFieldWizard">
                <img src="/static/img/copilot.png" width="15" height="15" style="margin-right: 5px" />
                Supsis Asistan
            </SupsisButton>
            <SupsisButton class="download-btn" :disabled="true" @click="downloadRecords" v-if="false">
                <i class="material-icons">get_app</i> {{ $t("tables.download") }}
            </SupsisButton>
        </div>
        <div class="right">
            <a-pagination
                v-if="recordCount > cursor.perPage"
                :current="cursor.page"
                :total="recordCount"
                :pageSize="cursor.perPage"
                show-size-changer
                show-quick-jumper
                :pageSizeOptions="['100', '250', '500', '750', '1000']"
                @change="onPageChange"
                @showSizeChange="onShowSizeChange"
                size="small"
            />
            <PermissionController :permissions="['automation.get']">
                <a-popover trigger="click" placement="topRight">
                    <template slot="content">
                        <div class="automation-popover custom-automation-popover">
                            <PermissionController :permissions="['automation.create']">
                                <div class="group">
                                    <div class="group-title">{{ $t("ticimax.createAutomation") }}</div>
                                    <div
                                        class="group-item event"
                                        @click="showCreateAutomationModal('table.record_created')"
                                    >
                                        <i class="material-icons">add</i> {{ $t("tables.recordCreated") }}
                                    </div>
                                    <div
                                        class="group-item event"
                                        @click="showCreateAutomationModal('table.record_updated')"
                                    >
                                        <i class="material-icons">update</i> {{ $t("tables.recordUpdated") }}
                                    </div>
                                    <div
                                        class="group-item event"
                                        @click="showCreateAutomationModal('table.record_deleted')"
                                    >
                                        <i class="material-icons">delete</i> {{ $t("tables.recordDeleted") }}
                                    </div>
                                </div>
                            </PermissionController>
                            <div class="group">
                                <div class="group-title">{{ $t("automation.automations") }}</div>
                                <div
                                    v-for="automation in tableAutomations"
                                    :key="automation._id"
                                    class="group-item automation"
                                    @click="goToAutomation(automation._id)"
                                >
                                    <component :is="'AutomationIcon'" class="myIcon" />
                                    {{ automation.name }}
                                </div>
                                <div v-if="!tableAutomations.length" class="no-automation">
                                    <i class="material-icons">info</i> {{ $t("tables.noAutomationDefined") }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <SupsisButton class="automate-btn" type="primary">
                        <i class="material-icons">settings_applications</i> {{ $t("tables.automateYourData") }}
                    </SupsisButton>
                </a-popover>
            </PermissionController>
        </div>

        <a-modal v-model="createAutomationModalVisible" :title="$t('ticimax.createAutomation')" @ok="createAutomation">
            <div class="automation-name-input">
                <div class="description">
                    <template v-if="selectedAutomationEvent === 'table.record_created'">
                        {{ $t("tables.nameTheAutomationAdd") }}
                    </template>
                    <template v-else-if="selectedAutomationEvent === 'table.record_updated'">
                        {{ $t("tables.nameTheAutomationUpdate") }}
                    </template>
                    <template v-else-if="selectedAutomationEvent === 'table.record_deleted'">
                        {{ $t("tables.nameTheAutomationDelete") }}
                    </template>
                </div>
                <a-input v-model="automationName" :placeholder="$t('automation.automationName')" />
            </div>
        </a-modal>

        <!-- TableAiAgent Modal -->
        <TableAiAgent
            v-if="showTableAiAgent"
            :tableId="tableId"
            @field-added="onFieldAdded"
            @field-updated="onFieldUpdated"
            @field-deleted="onFieldDeleted"
            @filters-updated="onFiltersUpdated"
            @group-updated="onGroupUpdated"
            @hidden-fields-updated="onHiddenFieldsUpdated"
            @color-conditions-updated="onColorConditionsUpdated"
            @multi-record-created="onMultiRecordCreated"
            @close="showTableAiAgent = false"
        />

        <!-- Export Settings Modal -->
        <Modal2
            v-if="showExportSettings"
            :title="$t('tables.downloadRecordsSettingsTitle')"
            @cancel="closeExportSettings"
            className="export-settings-modal keydown-prevent-modal"
            :showFooter="false"
            xlarge
        >
            <ExportSettings
                :fields="fields"
                :records="records"
                @start="onExportSettingsStart"
                @cancel="closeExportSettings"
            />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { AUTOMATION_API } from "../../../../api/automation";
import TableAiAgent from "../TableAiAgent.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import ExportSettings from "./components/ExportSettings.vue";
import { mapState } from "vuex";
import { checkTablePermission, getUserDepartments } from "../../../../utils/TablePermissionUtils";
import { TABLE_PERMISSION_SCOPES } from "../../../../utils/TablePermissionScopes";

export default Vue.extend({
    name: "TableFooter",
    components: {
        SupsisButton,
        TableAiAgent,
        Modal2,
        ExportSettings,
    },
    props: {
        recordCount: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        tableId: {
            type: String,
            required: true,
        },
        table: {
            type: Object,
            required: true,
        },
        cursor: {
            type: Object,
            required: true,
            default: () => ({
                page: 1,
                perPage: 100,
            }),
        },
        fields: {
            type: Array,
            default: () => [],
        },
        records: {
            type: Array,
            default: () => [],
        },
        selectedRecords: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            createAutomationModalVisible: false,
            automationName: "",
            selectedAutomationEvent: "",
            showTableAiAgent: false,

            // Export state
            showExportSettings: false,
            exportMode: "page", // 'page' | 'all'
        };
    },
    computed: {
        ...mapState({
            automations: (state) => state.automation.automations,
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
        userDepartments() {
            return getUserDepartments(this.user);
        },
        tableAutomations() {
            // Vuex'teki otomasyonlardan bu tabloya ait olanları filtrele
            return this.automations.filter(
                (automation) => automation.reference && automation.reference.table === this.tableId
            );
        },
        canCreateRecord() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_CREATE);
        },
        canImportRecords() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.BULK_IMPORT);
        },
        canExportRecords() {
            return this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT);
        },
        isRecordLimitExceeded() {
            return this.$feature.isTableRecordLimitExceeded(this.recordCount);
        },
        hasSelection() {
            return this.selectedRecords && this.selectedRecords.length > 0;
        },
        selectedRecordsCount() {
            return this.selectedRecords ? this.selectedRecords.length : 0;
        },
    },
    methods: {
        checkPermission(scope) {
            return checkTablePermission(this.table, scope, this.user, this.adminUser, this.userDepartments);
        },
        increaseLimit() {
            // Limit artırma işlemi
        },
        async createNewRecord() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_CREATE)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.$emit("create-new-record");
        },
        importRecords() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.BULK_IMPORT)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.$emit("open-import-modal");
        },
        exportRecords() {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.$emit("export-records");
        },
        // Export submenu actions
        openExport(mode) {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.exportMode = mode === "all" ? "all" : "page";
            this.showExportSettings = true;
        },
        closeExportSettings() {
            this.showExportSettings = false;
        },
        async onExportSettingsStart(settings) {
            this.showExportSettings = false;
            this.$emit("export-with-settings", {
                mode: this.exportMode,
                settings: settings
            });
            
            // Not: Gerçek indirme işlemi TableToolbar içindeki startPageExport veya startFullExport metodlarında yapılıyor
            // Activity log orada oluşturuluyor. Burada sadece export işleminin başladığını logluyoruz.
            // Activity log TableToolbar içinde indirme tamamlandığında oluşturulacak.
        },
        downloadRecords() {
            // Kayıtları indirme işlemi
        },
        automateData() {
            // Veri otomasyonu işlemi
        },
        showCreateAutomationModal(event) {
            this.selectedAutomationEvent = event;
            this.createAutomationModalVisible = true;
        },
        async createAutomation() {
            try {
                const automation = await AUTOMATION_API.createEmptyEventAutomation(
                    this.automationName,
                    this.selectedAutomationEvent,
                    {
                        filter: {
                            all: true,
                        },
                    },
                    {
                        table: this.tableId,
                    }
                );
                this.$message.success(this.$t("automation.eventAutomationCreatedSuccessfully"));
                this.createAutomationModalVisible = false;
                this.automationName = "";
                // Vuex sync edilecek, syncAutomations çağrısı API içinde yapılıyor
                this.goToAutomation(automation._id);
            } catch (error) {
                console.error("Error while creating automation", error);
                this.$message.error(this.$t("automation.automationCouldNotBeCreated"));
            }
        },
        goToAutomation(automationId) {
            this.$router.push(`/automations/${automationId}/design`);
        },
        onPageChange(page, pageSize) {
            this.$emit("change-cursor", {
                page: page,
                perPage: pageSize,
            });
        },
        onShowSizeChange(current, size) {
            this.$emit("change-cursor", {
                page: 1, // Sayfa boyutu değiştiğinde ilk sayfaya dön
                perPage: size,
            });
        },
        showFieldWizard() {
            this.showTableAiAgent = true;
            this.$emit("show-field-wizard");
        },
        onFieldAdded(field) {
            this.$emit("field-added", field);
        },
        onFieldUpdated(field) {
            this.$emit("field-updated", field);
        },
        onFieldDeleted(fieldId) {
            this.$emit("field-deleted", fieldId);
        },
        onFiltersUpdated(filters) {
            this.$emit("filters-updated", filters);
        },
        onGroupUpdated(group) {
            this.$emit("group-updated", group);
        },
        onHiddenFieldsUpdated(hiddenFields) {
            this.$emit("hidden-fields-updated", hiddenFields);
        },
        onColorConditionsUpdated(colorConditions) {
            this.$emit("color-conditions-updated", colorConditions);
        },
        onMultiRecordCreated() {
            this.$emit("multi-record-created");
        },
        exportSelectedRecords() {
            if (!this.hasSelection) return;
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.EXPORT)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            this.$emit("export-selected-records");
        },
    },
});
</script>

<style lang="scss">
.custom-automation-popover {
    .group-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px;
        transition: background-color 0.3s;

        &:hover {
            background-color: #f0f0f0;
        }

        &.automation {
            svg {
                fill: var(--color-icon-primary-default);
            }
        }

        &.event {
            i {
                font-size: 20px;
            }

            &:nth-child(2) i {
                color: #b2d8b2;
            }

            &:nth-child(3) i {
                color: #bad7f2;
            }

            &:nth-child(4) i {
                color: #f2c4c4;
            }
        }
    }

    .group-item i {
        font-size: 18px;
    }

    .no-automation {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 5px 10px;
        color: #999;
        font-style: italic;
    }
}
</style>

<style scoped lang="scss">
.table-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    height: 40px;
    z-index: 100;

    .left {
        display: flex;
        align-items: center;
        gap: 10px;

        :deep(.ant-pagination) {
            margin-left: 16px;

            .ant-select-selection-selected-value {
                font-size: 12px;
            }

            .ant-pagination-options-quick-jumper {
                font-size: 12px;

                input {
                    font-size: 12px;
                }
            }

            .ant-select-dropdown {
                z-index: 101;
            }
        }
    }

    .right {
        display: flex;
        align-items: center;
    }
}

.automation-name-input {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .description {
        font-size: 14px;
    }
}

.action-menu {
    display: flex;
    flex-direction: column;

    .action-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
            
            &:hover {
                background-color: transparent;
            }
        }

        .material-icons {
            margin-right: 8px;
        }
    }
}
</style>
